import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  alertsGroupTypes,
  fetchSuccess,
  createAlertGroupSuccess,
  createAlertGroupError,
  setNotification,
  updateFilters
} from "../actions/alertsGroup";
import {
  fetchAlertsGroupEndPoint,
  createAlertsGroupEndPoint,
  editAlertsGroupEndPoint,
  deleteAlertsGroupEndPoint
} from "../../configuration";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";

function* fetchAlertsGroupSaga(action) {
  const filters = action?.payload;
  if (filters?.sortOrder && filters?.field) {
    filters.sort = [{ field: filters.field, order: filters.sortOrder }]
  }
  try {
    yield put(updateFilters(filters));
    let alertsGroupResponse;
    alertsGroupResponse = yield all([call(fetchAlertsGroupAPI, filters)]);
    yield put(
      fetchSuccess({
            alertsGroup: alertsGroupResponse[0]
        })
      );

  } catch (error) {
    yield put(alertsGroupTypes.fetchFailure(error.message));
  }
}

async function fetchAlertsGroupAPI(filters) {
  const name = filters?.name?filters.name:'';
  const description = filters?.description?filters.description:'';
  const filter = {
    $selection: `(name like '${name}') AND (description like '${description}')`,
    
  }
  if(filters?.sort){
    filter["$sort"]=filters.sort
  }  
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: filter,
    $limitnumber: filters?.limitnumber,
    $pagenumber: filters?.pagenumber,
  };
  const response = await fetch(fetchAlertsGroupEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "POST",
    body: JSON.stringify(body),

  });

  if (!response.ok) return [];
  const totalCount = response.headers.get('x-total-count');
  const data = await response.json();
  return { data, totalCount: Number(totalCount) || 0 };
}

function* createAlertGroupSaga(action) {
  const data = action.payload;
  try {
    let createAlertGroupResp;
    createAlertGroupResp = yield all([call(createAlertGroupApi, data)]);
    yield put(setNotification({
      type: "success",
      message: "Create alert group",
      description: "alert group created successfully.",
      duration: 2,
      style: { backgroundColor: "#d4edda", color: "#155724" },
    }));
  } catch (error) {
    yield put(setNotification({
      type: "error",
      message: "Create Alert Group",
      description: "Could not create alert group",
      duration: 2,
      style: { backgroundColor: "#FFECE0", color: "black" },
    }));
  }

  async function createAlertGroupApi(data) {
    let body = {
      accountName: sessionStorage.getItem("accountId"),
      billingaccountid: sessionStorage.getItem("accountId"),
      group: { kind: "ts.notificationgroup.alert",
               description: data.description,         
               groupemail:'testemail@verizon.com',         
               name: data.alertGroupName     
             },
      userids: data?.users
    ,
    };

   const response = await fetch(createAlertsGroupEndPoint(), {
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
     },
     method: "POST",
     body: JSON.stringify(body),
 
   });
  
   if (!response.ok) throw(new Error('response'));
     
   return response.json();
}
}

function* editAlertGroupSaga(action) {
  const data = action.payload;
  try {
    let createAlertGroupResps;
    createAlertGroupResps = yield all([call(editAlertGroupApi, data)]);
    yield put(setNotification({
      type: "success",
      message: "Edit alert group",
      description: "alert group updated successfully.",
      duration: 2,
      style: { backgroundColor: "#d4edda", color: "#155724" },
    }));
  } catch (error) {
    yield put(setNotification({
      type: "error",
      message: "Edit alert group",
      description: "Could not update alert group",
      duration: 2,
      style: { backgroundColor: "#FFECE0", color: "black" },
    }));
  }

  async function editAlertGroupApi(data) {
    let body = {
      accountName: sessionStorage.getItem("accountId"),
      billingaccountid: sessionStorage.getItem("accountId"),
      group: { kind: "ts.notificationgroup.alert",
               description: data.description,         
               groupemail:'testemail@verizon.com',         
               name: data.alertGroupName,               
             },
      id:data.id,  
      userids: data?.users,
    };

   const response = await fetch(editAlertsGroupEndPoint(), {
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
     },
     method: "PATCH",
     body: JSON.stringify(body),
 
   });
  
   if (!response.ok) throw(new Error('response'));
     
   return response.json();
}
}



function* deleteAlertGroupSaga(action) {
  const data = action.payload;
  try {
    let createAlertGroupResps;
    createAlertGroupResps = yield all([call(deleteAlertGroupApi, data)]);
    yield put(setNotification({
      type: "success",
      message: "Delete alert group",
      description: "alert group deleted successfully.",
      duration: 2,
      style: { backgroundColor: "#d4edda", color: "#155724" },
    }));
  } catch (error) {
    yield put(setNotification({
      type: "error",
      message: "Delete Alert Group",
      description: "Could not delete alert group",
      duration: 2,
      style: { backgroundColor: "#FFECE0", color: "black" },
    }));
  }

  async function deleteAlertGroupApi(data) {
    let body = {
      accountName: sessionStorage.getItem("accountId"),
      billingaccountid: sessionStorage.getItem("accountId"),
      force:true,
      id:data?.id,
      name:data?.name  
    };

   const response = await fetch(deleteAlertsGroupEndPoint(), {
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
     },
     method: "DELETE",
     body: JSON.stringify(body),
 
   });
  
   if (!response.ok) throw(new Error('response'));
     
   return response;
}
}

function* downloadSaga() {
  try {
    const response = yield call(fetchAlertsGroupAPI,[]);
    JSONToCSVDownload(userCSVFormat(response?.data || []), "alertsGroupList_download.csv");
    yield put(setNotification({
      type: "success",
      message: "Export",
      description: "Exported Successfully",
      duration: 2,
      style: { backgroundColor: "#d4edda", color: "#155724" },
    }));
  } catch (error) {
    console.log("error", error);
    yield put(setNotification({
      type: "error",
      message: "Export",
      description: "Could not export",
      duration: 2,
      style: { backgroundColor: "#FFECE0", color: "black" },
    }));
  }
}

const userCSVFormat = (jsonArray) => {
    
    if (!Array.isArray(jsonArray)) return [];    
    return jsonArray.map((json) => ({
      name: json?.name,
      description: json?.description,
      numberOfUsers: json?.users?.length
    }));
  };

export function* FetchAlertsGroupSaga() {
  yield takeEvery(alertsGroupTypes.FETCH_REQUEST, fetchAlertsGroupSaga);
}

export function* CreateAlertsGroupSaga() {
  yield takeEvery(alertsGroupTypes.CREATE_REQUEST, createAlertGroupSaga);
}

export function* EditAlertsGroupSaga() {
  yield takeEvery(alertsGroupTypes.EDIT_REQUEST, editAlertGroupSaga);
}

export function* DeleteAlertGroupSaga() {
  yield takeEvery(alertsGroupTypes.DELETE_REQUEST, deleteAlertGroupSaga);
}

export function* ExportAlertGroupSaga() {
  yield takeEvery(alertsGroupTypes.EXPORT_SAGA, downloadSaga);
}
